// TODO: move this file to @occc/validation lib

export const isStringExactly = (value: number) => `Must be exactly ${value} symbols`;
export const isStringLengthUpTo = (value: number) => `Must be up to ${value} symbols`;
export const isStringLengthGreaterThan = (value: number) => `Must be at least ${value} symbols`;
export const isGreaterThan = (value: number) => `Must be greater than ${value}`;
export const isGreaterThanOrEqualTo = (value: number) =>
  `Must be greater than or equal to ${value}`;
export const isLessThan = (value: number) => `Must be less than ${value}`;
export const isLessThanOrEqualTo = (value: number) => `Must be less than or equal to ${value}`;
export const isSelectedMoreThen = (value: number) => `Must select at least ${value} item`;
export const isRangeBetween = (min: number, max: number) =>
  `Must be a number between ${min} and ${max}`;

export const IS_REQUIRED = 'This field is required';
export const IS_POSITIVE = 'Must be greater than zero.';
export const IS_VALID = 'Must be in a valid format.';
export const IS_URL = 'Must be a valid URL';
export const IS_MEMBERSHIP_LIMIT_LESS_THAN_GLOBAL =
  'Per Member fulfillment limits must be lower than the Global limit';
export const IS_LATITUDE_VALID_RANGE = 'Latitude coordinate should be between -90 and 90';
export const IS_LONGITUDE_VALID_RANGE = 'Longitude coordinate should be between -180 and 180';
export const IS_ZIP_CODE = 'Must be a valid zip code';
export const MINIMUM_ITEMS_ERROR_MESSAGE_TEXT = 'This field must have at least 1 item';
// The variable below contains an error message for numbers that our API scalar supports.
export const MAX_32_BIT_INTEGER_ERROR_MESSAGE_TEXT =
  'This field should be less than or equal to 2147483647';
export const FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT =
  'Offer fulfillment priority must be between 1 and 1000';
export const IS_INTEGER = 'Must be integer value';
export const IS_DATE_VALID = 'Incorrect date format';
export const IS_TIME_VALID = 'Incorrect time format';

export const CHARACTER_LIMIT_EXCEEDED = 'Character limit exceeded';
export const PUBLISH_BEFORE_EXPIRE = 'End date/time must be after start date/time';
